import type { RootState } from 'store'

export const getIsTutorialActive = (state: RootState) =>
  state.tutorial.currentStep !== null
export const getSteps = (state: RootState) => state.tutorial.steps
export const getCurrentStepData = (state: RootState) => {
  if (state.tutorial.currentStep === null) return null
  return state.tutorial.steps[state.tutorial.currentStep]
}
// Список фильтров
export const getFiltersCollection = (state: RootState) => {
  const step = getCurrentStepData(state)
  if (!step) return null
  return step.filtersCollection
}
// Список значений в фильтрах
// ex: { countryFilter: ['France', 'Italy'] }
export const getFiltersData = (state: RootState) => {
  if (state.tutorial.currentStep === null) return null
  return state.tutorial.steps?.[state.tutorial.currentStep]?.filterData ?? null
}
// Открытый фильтр
// ex: 'countryFilter'
export const getOpenedFilter = (state: RootState) => {
  if (state.tutorial.currentStep === null) return null
  return (
    state.tutorial.steps?.[state.tutorial.currentStep]?.openedFilter ?? null
  )
}
// Выбранные фильтры
// ex: { countryFilter: ['France'] }
export const getFiltersState = (state: RootState) => {
  if (state.tutorial.currentStep === null) return null
  return (
    state.tutorial.steps?.[state.tutorial.currentStep]?.filtersState ?? null
  )
}
// Выбранные фильтры (которые отобразятся в шапке)
// ex: { countryFilter: ['France'] }
export const getAppliedFilters = (state: RootState) => {
  if (state.tutorial.currentStep === null) return null
  return (
    state.tutorial.steps?.[state.tutorial.currentStep]?.appliedFilters ?? null
  )
}
export const getCurrentStepIndex = (state: RootState) => {
  return state.tutorial.currentStep
}

export const getFullFilterState = (state: RootState) => {
  const openedFilter = getOpenedFilter(state)
  const filtersState = getFiltersState(state)
  const filterData = getFiltersData(state)
  const filtersCollection = getFiltersCollection(state)
  return {
    openedFilter,
    filtersState,
    filterData,
    filtersCollection,
  }
}
